import React from 'react'

import EditCompanyForm from '../../modules/Company/components/EditCompanyForm'
export default function EditCompanyPage() {
  return <EditCompanyForm />
}
